(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6287],{

/***/ 76287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content085": function() { return /* binding */ Content085; },
  "default": function() { return /* binding */ Content085_Content085; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/widgets/content/Content085/Content085.module.scss
var Content085_module = __webpack_require__(95939);
var Content085_module_default = /*#__PURE__*/__webpack_require__.n(Content085_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/components/widgets/content/Content085/LeftBlock/LeftBlock.module.scss
var LeftBlock_module = __webpack_require__(72986);
var LeftBlock_module_default = /*#__PURE__*/__webpack_require__.n(LeftBlock_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content085/LeftBlock/LeftBlock.jsx




var LeftBlock = function(_param) {
    var payload = (0,_extends/* default */.Z)({}, _param);
    var ref, ref1, ref2;
    var ref3;
    var title = (ref3 = payload === null || payload === void 0 ? void 0 : payload.leftTitle) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var description = (ref4 = payload === null || payload === void 0 ? void 0 : payload.leftDescription) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var buttonText = (ref5 = payload === null || payload === void 0 ? void 0 : (ref = payload.leftButton) === null || ref === void 0 ? void 0 : ref.buttonText) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var slug = (ref6 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.leftButton) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.page) === null || ref2 === void 0 ? void 0 : ref2.slug) !== null && ref6 !== void 0 ? ref6 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LeftBlock_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                color: "light",
                className: (LeftBlock_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                color: "light",
                className: (LeftBlock_module_default()).description,
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
                className: (LeftBlock_module_default()).button,
                slug: slug,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "light",
                        appearance: "bigger",
                        children: buttonText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (LeftBlock_module_default()).icon,
                        name: "arrow_right"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LeftBlock_LeftBlock = ((/* unused pure expression or super */ null && (LeftBlock)));

;// CONCATENATED MODULE: ./src/components/widgets/content/Content085/LeftBlock/index.js


// EXTERNAL MODULE: ./src/components/Forms/index.js + 17 modules
var Forms = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./src/features/widgets/widgets.config.js
var widgets_config = __webpack_require__(52853);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./src/components/widgets/content/Content085/RightBlock/RightBlock.module.scss
var RightBlock_module = __webpack_require__(54799);
var RightBlock_module_default = /*#__PURE__*/__webpack_require__.n(RightBlock_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content085/RightBlock/RightBlock.jsx









var RightBlock = function(_param) {
    var payload = (0,_extends/* default */.Z)({}, _param);
    var ref, ref1, ref2, ref3;
    var ref4;
    var title = (ref4 = payload === null || payload === void 0 ? void 0 : payload.rightTitle) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var description = (ref5 = payload === null || payload === void 0 ? void 0 : payload.rightDescription) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var buttonText = (ref6 = payload === null || payload === void 0 ? void 0 : (ref = payload.rightButton) === null || ref === void 0 ? void 0 : ref.buttonText) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var link = (ref7 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.rightButton) === null || ref1 === void 0 ? void 0 : ref1.link) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8;
    var type = (ref8 = payload === null || payload === void 0 ? void 0 : (ref2 = payload.rightButton) === null || ref2 === void 0 ? void 0 : ref2.type) !== null && ref8 !== void 0 ? ref8 : "form";
    var ref9;
    var form = (ref9 = payload === null || payload === void 0 ? void 0 : (ref3 = payload.rightButton) === null || ref3 === void 0 ? void 0 : ref3.form) !== null && ref9 !== void 0 ? ref9 : {};
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("085rightBlock", payload.id, widgets_config/* WIDGETS_REGISTRY.CONTENT */.R.CONTENT);
    var query = (0,router.useRouter)().query;
    var ref10 = (0,hooks/* useToggle */.OT)(), opened = ref10.opened, onOpen = ref10.onOpen, onClose = ref10.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (RightBlock_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                color: "light",
                className: (RightBlock_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                color: "light",
                className: (RightBlock_module_default()).description,
                children: description
            }),
            type === "form" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Action */.aU, {
                onClick: onOpen,
                className: (RightBlock_module_default()).button,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "light",
                        appearance: "bigger",
                        children: buttonText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (RightBlock_module_default()).icon,
                        name: "arrow_right"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
                className: (RightBlock_module_default()).button,
                link: link,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "light",
                        appearance: "bigger",
                        children: buttonText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (RightBlock_module_default()).icon,
                        name: "arrow_right"
                    })
                ]
            }),
            opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalWrapper */.AB, {
                onCloseModal: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* Form */.l0, {
                    item: form,
                    metaData: {
                        page: query.slug
                    },
                    instanceId: instanceId,
                    onReset: onClose
                })
            })
        ]
    });
};
/* harmony default export */ var RightBlock_RightBlock = ((/* unused pure expression or super */ null && (RightBlock)));

;// CONCATENATED MODULE: ./src/components/widgets/content/Content085/RightBlock/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content085/Content085.jsx







var Content085 = function(param) {
    var payload = param.payload;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var ref;
    var image = (ref = payload === null || payload === void 0 ? void 0 : payload.leftImage) !== null && ref !== void 0 ? ref : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content085_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content085_module_default()).blocks,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                        image: image,
                        className: (Content085_module_default()).image
                    }),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftBlock, (0,_object_spread/* default */.Z)({}, payload)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBlock, (0,_object_spread/* default */.Z)({}, payload))
                ]
            })
        })
    });
};
/* harmony default export */ var Content085_Content085 = (Content085);


/***/ }),

/***/ 95939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content085_wrapper__3EKqK","blocks":"Content085_blocks__Ajxmd","image":"Content085_image__m4age"};

/***/ }),

/***/ 72986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LeftBlock_wrapper__ryqfk","title":"LeftBlock_title__IOCoG","description":"LeftBlock_description__cM0IG","button":"LeftBlock_button__CVJhy","icon":"LeftBlock_icon__uo5Ck"};

/***/ }),

/***/ 54799:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RightBlock_wrapper__5_Jl5","title":"RightBlock_title___22Vw","description":"RightBlock_description__ms3OD","button":"RightBlock_button__QUZFk","icon":"RightBlock_icon__5swEn"};

/***/ })

}]);